import { render, staticRenderFns } from "./leaveDetail.vue?vue&type=template&id=372ff56d&scoped=true&"
import script from "./leaveDetail.vue?vue&type=script&lang=js&"
export * from "./leaveDetail.vue?vue&type=script&lang=js&"
import style0 from "./leaveDetail.vue?vue&type=style&index=0&id=372ff56d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372ff56d",
  null
  
)

export default component.exports